module.exports = __webpack_public_path__ + "static/media/robogoose-green.62510c47.png";